import { render, staticRenderFns } from "./TherapySignIn.vue?vue&type=template&id=7a57ab33"
import script from "./TherapySignIn.vue?vue&type=script&lang=js"
export * from "./TherapySignIn.vue?vue&type=script&lang=js"
import style0 from "./TherapySignIn.vue?vue&type=style&index=0&id=7a57ab33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports